export const experienceData = [
  {
    id: 1,
    company: "Deloitte India",
    jobtitle: "Senior Analyst",
    startYear: "October 2023",
    endYear: "October 2024",
    skills: "React js,Redux,Hooks,Context API,Postman,API integration,UI Developer,Bootstrap,HTML,CSS,Git,Jira,Java Springboot"
  },
  {
    id: 2,
    company: "Hanriver Technology",
    jobtitle: "Frontend Developer",
    startYear: "February 2022",
    endYear: "July 2023",
    skills: "React js,Redux,Vue js,Figma,Miro,Postman,API integration,UI Developer,Bootstrap,HTML,CSS,Git,Notion"
  },
  {
    id: 3,
    company: "JeevaOrganic Pvt Ltd",
    jobtitle: "Associate Software Engineer",
    startYear: "September 2021",
    endYear: "December 2021",
    skills: "UI Developer,Bootstrap,HTML,CSS,Git,Jira,PHP Codeignitor,Mysql,Jira,ERP"
  },
  {
    id: 4,
    company: "Zuesso Business Solutions Pvt. Ltd.",
    jobtitle: "Vue Js Developer",
    startYear: "August 2020",
    endYear: "August 2021",
    skills: "React js,Redux,Vuejs,Postman,API integration,UI Developer,Bootstrap,HTML,CSS,Git"
  },
  
];
